/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Pricing_FreeInputs */

const en_agent_authorization_pricing_free = /** @type {(inputs: Agent_Authorization_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const zh_agent_authorization_pricing_free = /** @type {(inputs: Agent_Authorization_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Agent_Authorization_Pricing_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_pricing_free = /** @type {((inputs?: Agent_Authorization_Pricing_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Pricing_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_pricing_free(inputs)
	return zh_agent_authorization_pricing_free(inputs)
});
export { agent_authorization_pricing_free as "agent.authorization.pricing.free" }